import React from "react"
import clsx from 'clsx'
import DataTable from "../../DataTable/DataTable"

class FolioBuilderPaymentLogs extends React.Component {
  constructor(props) {
    super(props)
  }

  render() {
    var tabClasses = clsx({
      'active': this.props.active_tab == 'payments',
      'tab-pane': true,
    });

    return(
      <div className={tabClasses} id="payments">
        <div className="row">
          <div className="col-sm-12">
            <DataTable endpoint={this.props.payment_logs_path} date_format={this.props.date_format} />
          </div>
        </div>
      </div>
    )
  }
}

export default FolioBuilderPaymentLogs